import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import {
  Book as BookIcon,
} from '@mui/icons-material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function TopAuthorsChart({ stats, isLoading }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // Préparer les données pour le graphique en barres horizontales
  const chartData = stats?.topAuteurs && Array.isArray(stats.topAuteurs) && stats.topAuteurs.length > 0
    ? stats.topAuteurs
        .map((auteur) => ({
          name: auteur.nom_complet || t('homePage.unnamed'),
          value: parseInt(auteur.nombre_livres) || 0,
          auteurId: auteur.id, // Ajouter l'ID pour la navigation
        }))
        .filter(item => item.value > 0)
    : [];

  if (isLoading) {
    return null;
  }

  const handleBarClick = (data, index) => {
    if (chartData[index] && chartData[index].auteurId) {
      navigate(`/auteurs/${chartData[index].auteurId}`);
    }
  };

  if (!stats?.topAuteurs || !Array.isArray(stats.topAuteurs) || chartData.length === 0) {
    return null;
  }

  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2, mb: 4 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <BookIcon sx={{ fontSize: 24, color: '#e91e63', mr: 1 }} />
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
            {t('homePage.top5Authors')}
          </Typography>
        </Box>
        <Box
          sx={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            '& svg': {
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
            },
            '& *': {
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
            },
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            return false;
          }}
          onSelectStart={(e) => {
            e.preventDefault();
            return false;
          }}
        >
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis 
                dataKey="name" 
                type="category" 
                width={150}
                tick={{ fontSize: 12 }}
              />
              <Tooltip />
              <Bar 
                dataKey="value" 
                fill="#e91e63"
                radius={[0, 8, 8, 0]}
                onClick={handleBarClick}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill="#e91e63"
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}

export default TopAuthorsChart;


